<template>
  <section class="pickup-ad-container-wrapper">
    <h1>ピックアップ</h1>

    <SpiningDubblesLoading v-if="isLoading" class="loading" />
    <div v-else-if="pickupAds.length > 0">
      <PickupAdLinkItem
        v-for="(item, i) in pickupAds"
        v-bind="item"
        :key="`pickup_ad_${i}`"
        class="pickup-ad-article"
        @read="$emit('read', $event)"
      />
    </div>
    <p v-else class="non-registered">ピックアップが登録されていません</p>
  </section>
</template>

<script>
import SpiningDubblesLoading from '@v2/atoms/SpiningDubblesLoading.vue';
import PickupAdLinkItem from '@v2/molecules/common/pickup_ads/LinkItem.vue';

export default {
  name: 'PickupAdShowList',
  components: { SpiningDubblesLoading, PickupAdLinkItem },
  props: {
    /**
     * ローディングフラグ
     */
    isLoading: {
      type: Boolean,
      required: true,
    },
    /**
     * ピックアップ広告情報
     */
    pickupAds: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
.pickup-ad-container-wrapper
  border: 1px solid $color-border-container
  border-radius: 5px
  background-color: $color-background-basic
  padding: 12px 20px 30px
  width: 305px
  max-height: 600px
  overflow-y: auto
  margin: 0 auto 0 auto
  h1
    font: $font-label
    color: $color-text-basic
    border-bottom: 1px solid $color-border-bottom
    margin: 0
    padding-bottom: 12px
  .pickup-ad-article
    border-bottom: 1px solid $color-border-bottom
  .loading
    margin: 50px auto 20px
  .non-registered
    margin: 12px 0 0 0
    font: $font-basic
</style>
